<template>
  <div class="btns">
    <drag-modal :visible="visible" @cancel="reset" title="案件信息" width="584px">
      <a-form-model ref="newforms" :model="form" :rules="rules" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }"
        class="form" v-if="step == 0">
        <a-form-model-item label="请选择您要反馈的用户：" prop="user_ids" style='margin-bottom:20px;'>
          <a-select v-model="form.user_ids" placeholder="请选择" mode="multiple" show-search class="nselect"
            option-filter-prop="children" :filter-option="filterOption">
            <a-select-option v-for="i in userList" :key="i.id">{{ i.uname }}</a-select-option>
          </a-select>
          <!--<a-input type="textarea" placeholder="请输入您要分享的用户手机号：" style="height:120px;" v-model="form.phone"></a-input>-->
        </a-form-model-item>
        <!--<div class="mess">如需分享多个，请输入#分隔</div>-->
        <a-form-model-item :wrapper-col="{ span: 16, offset: 5 }">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button type="primary" style="margin-right: 20px; width: 148px">反馈</a-button>
          </a-popconfirm>
          <a-button style="background: #b2c9e1; color: #fff; width: 148px" @click="reset">取消</a-button>
        </a-form-model-item>
      </a-form-model>
      <a-row class="form" v-else>
        <div class="tit" style="color:#24c224;">反馈成功：</div>
        <a-col :span="24">
          <div class="rows">
            <span> {{ call.success_phones }}</span>
          </div>
        </a-col>
        <div class="tit" style="color:#f00;" v-show="call.fail_phones.length > 0">反馈失败：</div>
        <a-col :span="24" v-show="call.fail_phones.length > 0">
          <div class="rows">
            <span v-for="i in call.fail_phones"> {{ i }}</span>
          </div>
        </a-col>
        <a-form-model-item :wrapper-col="{ span: 16, offset: 8 }">
          <a-button type="primary" style="width: 148px;margin-top: 20px;" @click="reset">关闭</a-button>
        </a-form-model-item>
      </a-row>
    </drag-modal>
    <div class="flex">
      <List></List>
      <a-button type="primary" icon="share-alt" @click="visible = true">反馈</a-button>
    </div>
  </div>
</template>
<script>
import { shareAdd } from '@/server/debtor'
import { accUserList } from '@/server/user'
import List from './list'
export default {
  name: 'Share',
  data() {
    return {
      step: 0,
      visible: false,
      call: {
        success_phones: [],
        fail_phones: []
      },
      form: {
        user_ids: []
      },
      userList: [],
      rules: {
        user_ids: [{ required: true, trigger: 'change', message: '请选择您要分享的用户', }],  //
      }

    }
  },
  components: { List },
  created() {
    accUserList({ is_inner: 0 }).then(e => {
      this.userList = e.list
    })
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    reset() {
      this.form.user_ids = []
      this.step = 0
      this.visible = false;
    },
    getNameList() {
      const phones = this.userList.filter(ele => {
        return this.form.user_ids.indexOf(ele.id) >= 0
      }).map(ele => {
        return ele.uname
      })
      return phones.join(';')
    },
    confirm() {
      this.$refs.newforms.validate((valid) => {
        if (valid) {
          const names = this.getNameList()
          shareAdd({ cause_id: this.$store.state.cause.id, user_ids: this.form.user_ids }).then(e => {
            this.call = {
              success_phones: names,
              fail_phones: ''
            }
            this.step = 1;
          })
        }
      })

    },
  }
}
</script>
<style lang="less" scoped>
.btns {
  display: inline-block;
  margin-right: 20px;

  .flex {
    display: flex;
  }
}

.form {
  /deep/.ant-form-item {
    margin: 0;
  }

  .mess {
    margin-bottom: 20px;
  }

}

.rows {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  margin: 10px 0;
  min-height: 40px;
}

.tit {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
</style>